import { getCarModel } from '@/api/car_model.js'
import { getCarType } from '@/api/car.js'
import { getCarCompany } from '@/api/car_company.js'

/**
 * Справочники машин (модели, типы, марки) — один раз за сессию.
 * Не включает список автомобилей (getCars), только справочники для селектов.
 */
export const state = () => ({
  carModels: [],
  carTypes: [],
  carCompanies: [],
})

export const mutations = {
  setCarModels(state, list) {
    state.carModels = Array.isArray(list) ? list : []
  },
  setCarTypes(state, list) {
    state.carTypes = Array.isArray(list) ? list : []
  },
  setCarCompanies(state, list) {
    state.carCompanies = Array.isArray(list) ? list : []
  },
}

export const actions = {
  /** Подгрузить справочники, если ещё не загружены (один раз за сессию). */
  async loadCarRefsIfNeeded({ state, commit }) {
    const needModels = state.carModels.length === 0
    const needTypes = state.carTypes.length === 0
    const needCompanies = state.carCompanies.length === 0
    if (!needModels && !needTypes && !needCompanies) return

    const [modelsRes, typesRes, companiesRes] = await Promise.all([
      needModels ? getCarModel() : Promise.resolve(null),
      needTypes ? getCarType() : Promise.resolve(null),
      needCompanies ? getCarCompany() : Promise.resolve(null),
    ])
    if (needModels && modelsRes?.data) commit('setCarModels', modelsRes.data)
    if (needTypes && typesRes?.data) commit('setCarTypes', typesRes.data)
    if (needCompanies && companiesRes?.data)
      commit('setCarCompanies', companiesRes.data)
  },
}

export const getters = {
  carModels: (state) => state.carModels,
  carTypes: (state) => state.carTypes,
  carCompanies: (state) => state.carCompanies,
}
